import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import React from "react";

interface MarqueeComponentProps {
  parts: { text: string }[];
}

export default function MarqueeComponent({ parts }: MarqueeComponentProps) {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    setEnabled(true);
  }, []);

  return (
    <section className="min-h-[1vh] bg-white py-2">
      {/* Top horizontal rule */}

      {/* Marquee container with a blurred backdrop */}
      <div className="backdrop-blur-md border-t border-b border-black overflow-hidden">
        <div className="relative flex whitespace-nowrap text-gray-700 hover:pause-marquee py-4">
          {enabled && (
            <Marquee gradient={false} speed={50} loop={0} autoFill={true}>
              {parts &&
                parts.map((part, index) => (
                  <React.Fragment key={index}>
                    <span className="mx-4">
                      {part.text}
                    </span>
                    <span className="mx-4">✦</span>
                  </React.Fragment>
                ))}
            </Marquee>
          )}
        </div>
      </div>

      {/* Bottom horizontal rule */}
    </section>
  );
}
